export const initialData = {
  nome: '',
  especifica: false,
  atividade_id: null,
  tipo_licenca_id: null,
  meio_analise_id: null,
}
export default initialData;
